import axios from 'axios';

export class CatalogContingencyService {
    getCatStatusContingencyTrust() {

        return axios.get('/fideicomiso/contingency/catalog', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data);
    }

    getCatLoanFlow() {
        return axios.get('/fideicomiso/catLoan/catalog', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data);
    }

    getCatInstitution() {
        return axios.get('/fideicomiso/institution/catalog', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data);
    }

    getCatInstitutionBbva() {
        return axios.get('/fiduciario/institutions', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data);
    }
}